import { render } from "./BidPlacer.vue?vue&type=template&id=b8369ca6&scoped=true"
import script from "./BidPlacer.vue?vue&type=script&lang=js"
export * from "./BidPlacer.vue?vue&type=script&lang=js"

import "./BidPlacer.vue?vue&type=style&index=0&id=b8369ca6&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8369ca6"]])

export default __exports__